var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#84DCC8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3359 42.666C19.3359 37.952 19.3359 35.5949 20.8004 34.1305C22.2649 32.666 24.6219 32.666 29.3359 32.666H42.6693C47.3833 32.666 49.7403 32.666 51.2048 34.1305C52.6693 35.5949 52.6693 37.952 52.6693 42.666C52.6693 47.3801 52.6693 49.7371 51.2048 51.2015C49.7403 52.666 47.3833 52.666 42.6693 52.666H29.3359C24.6219 52.666 22.2649 52.666 20.8004 51.2015C19.3359 49.7371 19.3359 47.3801 19.3359 42.666Z",
    fill: "#84DCC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9974 46.0007C37.8383 46.0007 39.3307 44.5083 39.3307 42.6673C39.3307 40.8264 37.8383 39.334 35.9974 39.334C34.1564 39.334 32.6641 40.8264 32.6641 42.6673C32.6641 44.5083 34.1564 46.0007 35.9974 46.0007Z",
    fill: "#1177BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 29.334C27.25 24.5015 31.1675 20.584 36 20.584C40.8325 20.584 44.75 24.5015 44.75 29.334V32.6733C45.6956 32.6821 46.5225 32.704 47.25 32.7583V29.334C47.25 23.1208 42.2132 18.084 36 18.084C29.7868 18.084 24.75 23.1208 24.75 29.334V32.7583C25.4775 32.704 26.3044 32.6821 27.25 32.6733V29.334Z",
    fill: "#1177BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPin);
export default __webpack_public_path__ + "static/media/payment-pin.962dc391cacab6abe18df0667202a116.svg";
export { ForwardRef as ReactComponent };